import { render, staticRenderFns } from "./SwapManagerDialog.vue?vue&type=template&id=54c65de4&scoped=true"
import script from "./SwapManagerDialog.vue?vue&type=script&lang=js"
export * from "./SwapManagerDialog.vue?vue&type=script&lang=js"
import style0 from "./SwapManagerDialog.vue?vue&type=style&index=0&id=54c65de4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c65de4",
  null
  
)

export default component.exports